import { render } from "./PickupModal.vue?vue&type=template&id=553cb6b4&scoped=true&ts=true"
import script from "./PickupModal.vue?vue&type=script&lang=ts"
export * from "./PickupModal.vue?vue&type=script&lang=ts"

import "./PickupModal.vue?vue&type=style&index=0&id=553cb6b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553cb6b4"]])

export default __exports__